import {
  EvmNFTCollection,
  EvmNFTCollectionContractName,
} from '@repo/types-client';

import { evmNFTCollections } from '../data';

/**
 * Retrieves an EVM NFT collection configuration by its contract name
 *
 * @param contract - The name of the NFT collection contract to look up
 * @returns The corresponding EVM NFT collection configuration
 * @throws {Error} If the contract name is not found in the collections
 *
 * @example
 * const collection = getEvmNFTCollectionByContractName('MyNFTCollection');
 */
export const getEvmNFTCollectionByContractName = (
  contract: EvmNFTCollectionContractName,
): EvmNFTCollection => {
  // Remove any spaces from the contract name for normalization
  const contractName = contract.replace(/ /g, '');

  // Find the collection key by matching the contract name
  const key = Object.keys(evmNFTCollections).find(
    (key) => evmNFTCollections[key]?.contractName === contractName,
  );

  // Throw error if the contract name wasn't found
  if (!key) {
    throw new Error('Invalid contract name');
  }

  return evmNFTCollections[key] as EvmNFTCollection;
};
